const getInquiringProviderUserLastName = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (business
    && business['Company Info']
    && business['Company Info']['Signer Last Name']) {
    return business['Company Info']['Signer Last Name'];
  }
  return null;
};

export default getInquiringProviderUserLastName;



// WEBPACK FOOTER //
// ./src/utils/print/getInquiringProviderUserLastName.js